var Pixel = Pixel || {};

Pixel.Trendii = (function (PixelBase) {

    var Trendii = PixelBase.extend({
        initialize: function (opts) {

        },

        pageView: function () {

        },

        purchaseSuccess: function (opts) {
            opts = opts || {};
            var data = opts.OrderInfoResult;

            if (window.trendiiSalesTrackingPost) {

                var products = [];

                if (data.Items) {
                    $.each(data.Items, function () {
                        products.push({
                            'id': this.Sku, 
                            'price': this.Price,
                            'quantity': this.Quantity
                        });
                    });
                }

                trendiiSalesTrackingPost(data.InvoiceNo, data.Total, products);
            }
        }
    });

    return Trendii;
})(Pixel.PixelBase);

!function (Pixel) {
    new Pixel.Trendii();
}(Pixel);
